export default __webpack_public_path__ + "static/media/logo.f9237c76.png";